import { ShopperAgentEmailConfigSchema } from "@redotech/redo-shopper-agent-settings-common/email-config";
import { ShopperAgentIMessageConfigSchema } from "@redotech/redo-shopper-agent-settings-common/imessage-config";
import { ShopperAgentRcsConfigSchema } from "@redotech/redo-shopper-agent-settings-common/rcs-config";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const shopperAgentAdminDemoModeSchema = z.object({
  emailAddresses: z.array(z.string()),
  phoneNumbers: z.array(z.string()),
  skipBufferTriggerKeys: z.array(z.string()),
  skipSentinelTriggerKeys: z.array(z.string()),
});

export const updateAdminShopperAgentSettings = {
  name: "updateAdminShopperAgentSettings" as const,
  input: z.object({
    teamId: zExt.objectId(),
    enabled: z.boolean(),
    iMessageConfig: ShopperAgentIMessageConfigSchema,
    /**
     * CRDB-only merchant setting. Defaulted so a stale admin bundle that
     * predates this field still saves instead of failing validation.
     */
    emailConfig: ShopperAgentEmailConfigSchema.default({}),
    /**
     * Staff capability gate. Optional so a stale admin bundle cannot clear it.
     */
    adminEnabled: z.boolean().optional(),
    adminAllowIMessage: z.boolean(),
    /**
     * Telnyx RCS agent id; empty disables RCS. Defaulted so a stale admin
     * bundle that predates this field still saves instead of failing validation.
     */
    adminRcsAgentId: z.string().default(""),
    /**
     * Merchant RCS opt-in, settable by staff so enabling RCS does not require
     * walking the merchant's playbook. Optional rather than defaulted: a stale
     * admin bundle omits it, and an omission must leave the merchant's own
     * choice alone instead of silently clearing it.
     */
    rcsConfig: ShopperAgentRcsConfigSchema.optional(),
    adminEnableActionAuthorizationLinks: z.boolean(),
    adminAllowCustomerPortalTextPopup: z.boolean().optional(),
    adminDemoMode: shopperAgentAdminDemoModeSchema,
  }),
  output: z.object({}),
};
